import { render } from "./HeroiconsOutlineMusicNote.vue?vue&type=template&id=dda5004e"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMusicNote.vue"]])

export default __exports__